import { useReceivedPaymentDetailContext } from "../../../context/ReceivedPaymentDetailContext"
import { useReceivedPaymentDetailServices } from "../../../hooks/useReceivedPaymentDetailServices"

export const useReceivedPaymentDetailHeader = () => {

    const { loadingReceivedPaymentDetail, setLoadingReceivedPaymentDetail } = useReceivedPaymentDetailContext()
    const { getExportChargeInstanceDebtorsService } = useReceivedPaymentDetailServices()
    const handleDownloadChargeInstanceData = async ({ charge_instance_id }) => {
        await getExportChargeInstanceDebtorsService({
            setLoading: setLoadingReceivedPaymentDetail,
            charge_instance_id
        })
        setLoadingReceivedPaymentDetail(false)
    }
    return {
        handleDownloadChargeInstanceData,
        loadingReceivedPaymentDetail
    }


}